/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on('click', '.Cart__Upsell--footer .Cart__Upsell-Heading', function(evt) {
    var upsellContainer = document.querySelector('.Cart__Upsell--footer');
    var upsellContent = upsellContainer.querySelector('.Cart__Upsell-Content');
    var upsellHeading = upsellContainer.querySelector('.Cart__Upsell-Heading');

    evt.preventDefault();
    upsellContent.classList.toggle('Cart__Upsell-Content--open');
    upsellHeading.classList.toggle('Cart__Upsell-Heading--open');
})

var slider=null, sliderList=[];
var renderCartUpsell = function(evt) {
    var upsellProgramContainers = document.querySelectorAll('.Cart__Upsell--program'), upsellProgramContainer, i, len;
    len=(upsellProgramContainers ? upsellProgramContainers.length : 0);

    for (i=0; i<len; i++) {
        upsellProgramContainer=upsellProgramContainers[i];
        if (upsellProgramContainer) {
            var upsellProgramProducts = upsellProgramContainer.querySelector('.Cart__Upsell-Products');
            var upsellProgramProduct = upsellProgramContainer.querySelectorAll('.Cart__Upsell-Product');
            var containerID = upsellProgramContainer.id;

            if (upsellProgramProduct.length === 0) {
                upsellProgramContainer.style.display = 'none';
                return;
            }

            sliderList[sliderList.length] = tns({
                container: '#'+containerID+'.Cart__Upsell--program .Cart__Upsell-Products',
                items: 2,
                gutter: 10,
                mouseDrag: true,
                loop: false,
                slideBy: 'page',
                rewind: true,
                navPosition: "bottom",
                controlsPosition: "bottom",
                prevButton: "#"+containerID+".Cart__Upsell--program .Cart__Upsell-Controls .prev-arrow",
                nextButton: "#"+containerID+".Cart__Upsell--program .Cart__Upsell-Controls .next-arrow",
                navContainer: '#'+containerID+'.Cart__Upsell--program .Cart__Upsell-Controls .dots',
            });

            $(upsellProgramContainer).find('.Cart__Upsell-Select').on('change', function() {
                var product_image = $(this).find(':selected').data("product-image");
                $(this).parent().parent().find("img").attr("src",product_image);
            });

            $(upsellProgramContainer).find('.Cart__Upsell-Product .Cart__Upsell-Bundle-Items').each(function(){
                // Find if we need to show the popup, or can just add the items. Also check the option name (ie Colour, Size, etc)
                var hasMultiItems = false, numItems, variantType='';
                $(this).find('select.js-add-to-bundle').each(function(){
                    if (this.options.length>1) {
                        hasMultiItems=true;
                        variantType=$(this).data('optionname');
                    }
                });
                // Update heading if the option is 'Size'
                if (variantType!=='') {
                    if (variantType.indexOf('Color')>=0 || variantType.indexOf('Colour')>=0) {
                        // leave as is
                    } else if (variantType.indexOf('Size')>=0) {
                        var titleStr = ''+$(this).children('h4').html();
                        titleStr=titleStr.replace('colours', 'sizes');
                        titleStr=titleStr.replace('Colours', 'Sizes');
                        $(this).children('h4').html(titleStr);
                    }
                }
                // No popup needed?
                if (!hasMultiItems) {
                    $(this).closest('.Cart__Upsell-Product').find('.Button--bundle-select').addClass('Button--no-modal').html('Add +');
                }

                // Update the dropdown in the upsell part
                numItems=$(this).find('.product__bundle-product').length;
                if (numItems>0) {
                    $(this).closest('.Cart__Upsell-Product').find('.Select__label').html(numItems+' item'+(numItems===1?'':'s'));
                }
            });

            $(upsellProgramContainer).find('.Cart__Upsell-Select').trigger('change');
        }
    } // end for (i in upsellProgramContainers)

    var addToCartButtons = document.querySelectorAll('.Button--add-to-cart');

    addToCartButtons.forEach(function(btn) {
        btn.addEventListener('click', function(evt) {
            evt.preventDefault();

            if ($(this).hasClass('Button--bundle-select')) {
                var bundleItemIds = $(this).data("bundle-ids").split(',');
                var bundleSize = $(this).data("bundle-product-count");

                itemsToAdd = [];
                var masterUniqueId = 'bundle-' + new Date().valueOf();

                for (let i = 0; i < bundleItemIds.length; i++) {

                    let component_properties = {
                        'parentUniqueId': masterUniqueId,
                        'parentUniqueIdIndex': masterUniqueId + '-' + i
                    }

                    itemsToAdd.push({
                        quantity: 1,
                        id: bundleItemIds[i],
                        properties: component_properties
                    })

                }

                var upsellDiscount = $(this).data("upsell-discount");
                var fromCollection = $(this).data("from-collection");

                itemsToAdd.push({
                    quantity: 1,
                    id: parseInt($(this).data("variant-id"),10),
                    properties: {
                        'masterUniqueId' : masterUniqueId,
                        'bundleSize': bundleSize,
                        "_cart_program_upsell": true,
                        "_upsell-discount": upsellDiscount,
                        "_fromCollection": fromCollection
                    }
                })

                // document.dispatchEvent(new CustomEvent('theme:loading:start'));
                // jQuery.post('/cart/add.js', {
                //     items: itemsToAdd
                // });
                // document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.dispatchEvent(new CustomEvent('theme:loading:start'));
                $.ajax({
                    method: 'POST',
                    url: '/cart/add.js',
                    data: {
                        "items": itemsToAdd
                    },
                    dataType: 'json',
                    success: function(response) {
                        document.dispatchEvent(new CustomEvent('product:added',{
                            bubbles: true,
                            detail: {
                                quantity: itemsToAdd.length
                            }
                        }));
                        document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    }
                });
                document.dispatchEvent(new CustomEvent('theme:loading:end'));

            } else {
                // Regular product
                // var variantId = parseInt( $(this).prev().find(":selected").data("variant-id"),10), itemProperties;
                var variantId = parseInt( $(this).data("variant-id"),10), itemProperties;

                var upsellDiscount = $(this).data("upsell-discount");
                var fromCollection = $(this).data("from-collection");

                itemProperties={
                    _cart_program_upsell: true,
                    "_upsell-discount": upsellDiscount,
                    "_fromCollection": fromCollection
                };
                if ($(this).data('upsellgroup')) {
                    itemProperties['_upsell_group']=''+$(this).data('upsellgroup');
                }

                document.dispatchEvent(new CustomEvent('theme:loading:start'));
                $.ajax({
                    method: 'POST',
                    url: '/cart/add.js',
                    data: {
                        id: variantId,
                        quantity: 1,
                        properties: itemProperties
                    },
                    dataType: 'json',
                    success: function(response) {
                        document.dispatchEvent(new CustomEvent('product:added',{
                            bubbles: true,
                            detail: {
                                variant: variantId,
                                quantity: 1
                            }
                        }));
                        document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    }
                });
            }
        });
    });

    var upsellContainer = document.querySelector('.Cart__Upsell--footer');
    if (upsellContainer) {
        var upsellProducts = upsellContainer.querySelector('.Cart__Upsell-Products');
        var upsellProduct = upsellContainer.querySelectorAll('.Cart__Upsell-Product');
        var upsellContent = upsellContainer.querySelector('.Cart__Upsell-Content');
        var upsellHeading = upsellContainer.querySelector('.Cart__Upsell-Heading');
        var upsellHeadingOpen = upsellHeading.querySelector('.arrow-up');

        // document.querySelector('.Cart__Upsell--footer .Cart__Upsell-Heading').addEventListener('click', function(evt) {
        //     console.log("toggle btn")
        //     evt.preventDefault();
        //     upsellContent.classList.toggle('Cart__Upsell-Content--open');
        //     upsellHeading.classList.toggle('Cart__Upsell-Heading--open');
        // });

        if (upsellProduct.length === 0) {
            upsellContainer.style.display = 'none';
            return;
        }

        const initSlider = () => {
            sliderList[sliderList.length] = tns({
                container: '.Cart__Upsell--footer .Cart__Upsell-Products',
                items: 2,
                gutter: 20,
                mouseDrag: true,
                loop: false,
                slideBy: 'page',
                rewind: true,
                navPosition: "bottom",
                controlsPosition: "bottom",
                prevButton: ".Cart__Upsell-Controls .prev-arrow",
                nextButton: ".Cart__Upsell-Controls .next-arrow",
                navContainer: '.Cart__Upsell-Controls .dots',
            });
        }
        initSlider();
    }
    cartValidation();
}

var derenderCartUpsell = function() {
    if(slider) {
        slider.destroy();
    }
    if (sliderList) {
        var i, len=sliderList.length;
        for (i=0; i<len; i++) {
            sliderList[i].destroy();
        }
        sliderList=[];
    }
}


/**
 * Adds validation to the cart draw by making the "accept_terms_and_conditions" mandatory.
 */


var cartValidation = function() {
    var cartDrawerFormSelectors = {
        form: '#js-cart-drawer-form',
        acceptConditions: 'input[name="accept_terms_and_conditions"]',
        acceptConditionsContainer: '.terms_and_conditions-container'
    };

    var cartDrawersColours = {
        error: 'red',
        noError: '#454545'
    };

    $(cartDrawerFormSelectors.form).on('submit', function (e) {
        if ($(cartDrawerFormSelectors.acceptConditions).prop('checked') == false) {
            e.preventDefault();
            $(cartDrawerFormSelectors.acceptConditionsContainer).css({
                'color': cartDrawersColours.error
            });
            window.alert('Please tick the box to agree to our Terms and Conditions and Privacy Policy');
        } else {
            $(cartDrawerFormSelectors.acceptConditionsContainer).css({
                'color': cartDrawersColours.noError
            });
        }
    });

    $(cartDrawerFormSelectors.acceptConditions).on('change', function () {
        $(cartDrawerFormSelectors.acceptConditionsContainer).css({
            'color': cartDrawersColours.noError
        });
    });
};

var UpsellModal = {
    bundleItemsToAdd: [],
    bundleItemsStartCount: 0,
    bundleButton: null,
    upsellGroup: "",
    init: function()
    {
        $('.drawer-modal-outer .drawer-modal').on('click', function(e){
            e.stopPropagation();
        });
        $('.drawer-modal-outer').on('click', function(){
            $(this).removeClass('open');
        });
        $('.drawer-modal-outer .drawer-modal .close-modal').on('click', function(e){
            e.preventDefault();
            UpsellModal.close();
        });
        document.addEventListener('cart:closed', function(){
            $('.drawer-modal-outer.open').removeClass('open');
        });

        $('#upsell-modal').on('click', '.Button--add-bundle', function(e){
            e.preventDefault();
            //console.log('== ADD BUNDLE ITEMS ==');
            var variantsToAdd=[], parentVariantID=0, bundleHandle='';
            $('#upsell-modal .product__bundle-product .js-add-to-bundle').each(function(){
                variantsToAdd.push( $(this).val() );
            });
            $('#upsell-modal .product__parent-bundle-product').each(function(){
                parentVariantID=$(this).val();
                bundleHandle=$(this).data('handle');
            });
            //console.log('variantsToAdd = ', variantsToAdd);

            $(this).attr('disabled', 'disabled');
            $(this).html('<div class="bundle-button-container"><span class="button-spinner-container"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></span> Please wait</div>');

            variantsToAdd.reverse();
            UpsellModal.bundleButton = this;
            UpsellModal.addBundleItemsToCart(variantsToAdd, parentVariantID, bundleHandle, UpsellModal.close);
        });
    },
    open: function()
    {
        $('#upsell-modal').removeClass('hidden');
        $('#upsell-modal-outer').css('opacity','').addClass('open');
    },
    close: function()
    {
        $('#upsell-modal').addClass('hidden');
        setTimeout(function(){ $('#upsell-modal-outer').css('opacity',0); },350);
        setTimeout(function(){ $('#upsell-modal-outer').removeClass('open'); },500);
    },
    setUpsellGroup: function(upsellGroup)
    {
        UpsellModal.upsellGroup = upsellGroup;
    },
    setContent: function(html)
    {
        $('#upsell-modal .drawer-modal__content').html(html);
    },
    addBundleItemsToCart: function(variantsToAdd, bundleParentID, bundleHandle, callback)
    {
        if (typeof(callback)!=='function') { callback=null; }
        if (typeof(variantsToAdd)!=='object') { return; }
        if (typeof(bundleParentID)==='undefined') { bundleParentID=0; }

        var masterUniqueId = 'bundle-' + new Date().valueOf();
        var cartItems = [], i, len;
        len=variantsToAdd.length;
        for (i=0; i<len; i++) {
            cartItems.push({
                id: variantsToAdd[i],
                quantity: 1,
                properties: {
                    //_cart_program_upsell: true, // should only be needed on parent item, since child items get price set to $0.00
                    parentUniqueId: masterUniqueId,
                    parentUniqueIdIndex: masterUniqueId+'-'+i
                }
            });
        }
        if (bundleParentID>0) {
            cartItems.push({
                id: bundleParentID,
                quantity: 1,
                properties: {
                    _cart_program_upsell: true,
                    masterUniqueId: masterUniqueId,
                    bundle: bundleHandle,
                    bundleSize: variantsToAdd.length,
                    _upsell_group: ''+UpsellModal.upsellGroup
                }
            });
        }

        UpsellModal.bundleItemsToAdd = cartItems;
        UpsellModal.bundleItemsStartCount = cartItems.length+1;
        UpsellModal.addNextBundleItemToCart(callback);
    },

    addNextBundleItemToCart: function(callback)
    {
        if (!UpsellModal.bundleItemsToAdd || UpsellModal.bundleItemsToAdd.length===0) {
            return;
        }


        $.post('/cart/add.js', {
            items: UpsellModal.bundleItemsToAdd,
        }, function() {
            UpsellModal.bundleButton.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: 0, quantity: UpsellModal.bundleItemsStartCount
                }
            }));
            $('#upsell-modal-outer').removeClass('open');
        });

    }
};

document.addEventListener('cart:render', renderCartUpsell);
document.addEventListener('cart:open', renderCartUpsell);
document.addEventListener('cart:closed', derenderCartUpsell);





// ADD PROGRAM TO CART JS
// Taken from v1.9
// Programs don't exist anymore, possibly remove and rebuild entire functionality

/*
var workoutsDropdowns = document.querySelectorAll('.workouts__select');
var addToCartButton = document.querySelector('.add-plan-to-cart'), allAddToCartButtons = document.querySelectorAll('.add-plan-to-cart');
if (workoutsDropdowns) {
  workoutsDropdowns.forEach(function(workoutSelect) {
    workoutSelect.addEventListener('change', getSelectedPlan);
  })
}

if (allAddToCartButtons) {
  allAddToCartButtons.forEach(function(addBtn) {
    addBtn.addEventListener('click', addWorkoutPlanToCart);
  });
}

function getSelectedPlan() {

  if ($(this).closest('.Workouts__form').length>0) {
    try{
      workoutsDropdowns = $(this).closest('.Workouts__form')[0].querySelectorAll('.workouts__select');
      addToCartButton = $(this).closest('.Workouts__form')[0].querySelector('.add-plan-to-cart');
    }catch(err){
      console.error(err);
    }
  }

  var handle='', firstSelectorValue, option2Selected=false, option3Selected=false;
  areAllOptionSelected = true;
  var hiddenInput = document.querySelector('[data-hidden-id]');

  firstSelectorValue=(workoutsDropdowns.length>0 ? workoutsDropdowns[0].value : '');
  if (firstSelectorValue==='bikini-build' && workoutsDropdowns.length>1) {
    $(workoutsDropdowns[1]).find("option[value=-round-3]").prop('disabled', true);
  } else if (firstSelectorValue==='booty' && workoutsDropdowns.length>1) {
    $(workoutsDropdowns[1]).find("option[value=-round-3]").prop('disabled', false);
  } else if (workoutsDropdowns.length>1) {
     $(workoutsDropdowns[1]).find("option[value=-round-3]").prop('disabled', false);
  }

  for(var i = 0; i < workoutsDropdowns.length; i++) {
    if (workoutsDropdowns[i].value === '-1') {
      areAllOptionSelected = false;
    } else if (i==1) {
      option2Selected = true;
    } else if (i==2) {
      option3Selected = true;
    }
  }

  var variantValue='';

    for(var i = 0; i < workoutsDropdowns.length; i++) {
      if (!workoutsDropdowns[i].getAttribute('data-variant-select') || workoutsDropdowns[i].getAttribute('data-variant-select')!=='1') {
        handle += (workoutsDropdowns[i].value!=='-1' ? workoutsDropdowns[i].value : '');
      } else {
        variantValue = ''+(workoutsDropdowns[i].value!=='-1' ? workoutsDropdowns[i].value : '');
        variantValue = variantValue.toLowerCase();
      }
    }

    if (this.dataset.workoutPrefix) {
      handle = this.dataset.workoutPrefix + (handle!==''?'-':'') + handle;
    }
    handle = handle.replace('--', '-');

    $.ajax({
      method: 'GET',
      url: '/products/' + handle + '.json',
      dataType: 'JSON',
      success: function(response) {
        addToCartButton.disabled = false;

        var variantIdx=0;

        if (variantValue!=='') {
            var i, len;
            variantIdx=-1;
            len=response.product.variants.length;
            for (i=0; i<len; i++) {
                var str=''+(response.product.variants[i].title ? response.product.variants[i].title : response.product.variants[i].option1);
                if (str.toLowerCase()==variantValue) {
                    variantIdx=i;
                    //console.log('variant = ', variantIdx, ' / id = ', response.product.variants[variantIdx].id, ' / price = ', response.product.variants[variantIdx].price);
                    break;
                }
            }
        }

        if (variantIdx<0) {

            // No variant selected
            addToCartButton.disabled = true;
            addToCartButton.innerHTML = 'N/A';
            addToCartButton.setAttribute('data-variant-id', '');
            hiddenInput.value = '';

        } else {

            if (window.theme.currencyConversionEnabled && window.theme.currencyConversionMethod == 'cc_on_site') {
              // Currency converter stuff
              var baseCurrency = window.theme.shopCurrency,
                newCurrency = document.querySelector('.CurrencySelector__Select') ? document.querySelector('.CurrencySelector__Select').value : null;
              var variantPrice = response.product.variants[variantIdx].price * 100;
              var baseFormated = formatMoney(variantPrice);
              var formattedMoney = formatMoney(variantPrice);
              var currency = baseCurrency;

              if (baseCurrency !== newCurrency) { // Only convert the price if the store is set to a different value right now.
                variantPrice = Currency.convert(variantPrice, baseCurrency, newCurrency);
                currency = newCurrency;
                if (window.theme.currencyConversionRoundAmounts) {
                  variantPrice = Math.round(variantPrice / 100) * 100;
                }
                formattedMoney = formatMoney(variantPrice, (moneyFormats[newCurrency][window.theme.currencyConversionMoneyFormat] || '{{amount}}'));
              }
              var buttonText = addToCartButton.dataset.buttonText || 'Join Now';
              addToCartButton.innerHTML = buttonText + ' <span data-money-convertible>' + formattedMoney + '</span>';
              var addToCartPrice = addToCartButton.querySelector('span');
              if (baseCurrency != newCurrency) {
                addToCartPrice.setAttribute('data-currency', currency);
                addToCartPrice.setAttribute('data-currency-' + newCurrency, formattedMoney);
                addToCartPrice.setAttribute('data-currency-' + baseCurrency, baseFormated);
              }
            } else if (window.theme.currencyConversionEnabled && window.theme.currencyConversionMethod == 'cc_multi_checkout') {
              newCurrency = document.querySelector('.CurrencySelector__Select--Multi') ? document.querySelector('.CurrencySelector__Select--Multi').value : null;
              var formattedMoney = formatMoney(response.product.variants[variantIdx].price, (moneyFormats[newCurrency][window.theme.currencyConversionMoneyFormat] || '{{amount}}'));
              var buttonText = addToCartButton.dataset.buttonText || 'Join Now';
              addToCartButton.innerHTML = buttonText + ' <span data-money-convertible>' + formattedMoney + '</span>';
              var addToCartPrice = addToCartButton.querySelector('span');
              addToCartPrice.setAttribute('data-currency', window.theme.moneyFormat);
            }
            addToCartButton.setAttribute('data-variant-id', response.product.variants[variantIdx].id);
            addToCartButton.setAttribute('data-price', response.product.variants[variantIdx].price);
            addToCartButton.setAttribute('data-sku', response.product.variants[variantIdx].sku);
            hiddenInput.value = response.product.variants[variantIdx].id;

        }
      },
      error: function(error) {
        addToCartButton.disabled = true;
        addToCartButton.innerHTML = 'N/A';
        addToCartButton.setAttribute('data-variant-id', '');
        hiddenInput.value = '';
      }
    });
}

function addWorkoutPlanToCart() {
  var optionalBundle = document.querySelector('.workouts__bundle--add');
  variantId = parseInt(this.getAttribute('data-variant-id'));
  var self = this;
  if (optionalBundle) {
    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1,
        properties: {
          _withBundle: true
        }
      },
      dataType: 'JSON',
      success: function(response) {
        $.ajax({
          method: 'POST',
          url: '/cart/add.js',
          data: {
            id: optionalBundle.value,
            quantity: 1,
            properties: {
              _bundleFor: variantId
            }
          },
          dataType: 'JSON',
          success: function(response) {
            self.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: variantId,
                quantity: 1
              }
            }));
          }
        });
      }
    });
    return;
  }
  $.ajax({
    method: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1,
    },
    dataType: 'JSON',
    success: function(response) {
      self.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: 1
        }
      }));
    }
  });
}
*/
